module.exports = __webpack_public_path__ + "static/media/mentee_mentoring_about2.d9a9a2b2.webp";